// Wraps a chart with axis TITLES — a rotated Y-axis label on the left and a
// centered X-axis label below — so every cartesian chart shows what each axis
// represents. Labels are optional; when empty the frame is a passthrough.
import type { ReactNode } from 'react';

interface Props {
  xLabel?: string;
  yLabel?: string;
  /** axis-title colour — customizable (defaults to slate) */
  color?: string;
  children: ReactNode;
}

export function ChartFrame({ xLabel, yLabel, color, children }: Props) {
  const hasX = Boolean(xLabel);
  const hasY = Boolean(yLabel);
  if (!hasX && !hasY) return <>{children}</>;
  const titleColor = color || '#64748b';

  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex min-h-0 flex-1">
        {hasY && (
          <div className="flex w-4 flex-shrink-0 items-center justify-center">
            <span
              className="max-h-full overflow-hidden whitespace-nowrap text-ellipsis text-[11px] font-semibold leading-none"
              style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)', color: titleColor }}
            >
              {yLabel}
            </span>
          </div>
        )}
        <div className="min-h-0 min-w-0 flex-1">{children}</div>
      </div>
      {hasX && <div className="flex-shrink-0 pt-0.5 text-center text-[11px] font-semibold leading-none" style={{ color: titleColor }}>{xLabel}</div>}
    </div>
  );
}
